import { useIntl } from 'react-intl';
import Input from 'src/componentes/input';
import LucideIcon from 'src/componentes/lucide-icon';
import HoverCard from 'src/componentes/hover-card';
import EditTranslate from './EditTranslate';
import ContentManager from 'src/componentes/content-manager';

const InputTranslate = ({
  maxLength,
  fieldDefault,
  valueDefault,
  labelDefault,
  fieldPT,
  valuePT,
  fieldEN,
  valueEN,
  fieldES,
  valueES,
  fieldIT,
  valueIT,
  fieldNL,
  valueNL,
  fieldFR,
  valueFR,
  fieldDE,
  valueDE,
  fieldTR,
  valueTR,
  fieldAR,
  valueAR,
  required,
  disabled,
  handleChangeInputTranslate,
  handleChangeEditTranslate,
  errorsFieldDefault,
  inputType,
  inputRows,
}) => {
  const intl = useIntl();

  const handleChangeInput = (field, value) => {
    handleChangeInputTranslate(field, value);
  };

  const renderInput = () => {
    return (
      <>
        <Input
          type={inputType ? inputType : 'text'}
          rows={inputRows ? inputRows : 1}
          maxLength={maxLength}
          model={{
            label: labelDefault,
            value: valueDefault,
            requestChange: (v) => handleChangeInput(fieldDefault, v),
            errors: errorsFieldDefault,
          }}
          required={required}
          disabled={disabled}
        />
      </>
    );
  };

  const handleTraducao = () => {
    ContentManager.addContent(
      <EditTranslate
        fieldDefault={fieldDefault}
        valueDefault={valueDefault}
        labelDefault={labelDefault}
        fieldPT={fieldPT}
        valuePT={valuePT}
        fieldEN={fieldEN}
        valueEN={valueEN}
        fieldES={fieldES}
        valueES={valueES}
        fieldIT={fieldIT}
        valueIT={valueIT}
        fieldNL={fieldNL}
        valueNL={valueNL}
        fieldFR={fieldFR}
        valueFR={valueFR}
        fieldDE={fieldDE}
        valueDE={valueDE}
        fieldTR={fieldTR}
        valueTR={valueTR}
        fieldAR={fieldAR}
        valueAR={valueAR}
        handleChangeEditTranslate={handleChangeEditTranslate}
        maxLength={maxLength}
        required={required}
        disabled={disabled}
        inputType={inputType}
        inputRows={inputRows}
      />
    );
  };

  const traducoes = [
    { label: labelDefault, field: true, value: valueDefault },
    { idioma: 'portugues', field: fieldPT, value: valuePT },
    { idioma: 'ingles', field: fieldEN, value: valueEN },
    { idioma: 'espanhol', field: fieldES, value: valueES },
    { idioma: 'italiano', field: fieldIT, value: valueIT },
    { idioma: 'holandes', field: fieldNL, value: valueNL },
    { idioma: 'frances', field: fieldFR, value: valueFR },
    { idioma: 'alemao', field: fieldDE, value: valueDE },
    { idioma: 'turco', field: fieldTR, value: valueTR },
    { idioma: 'arabe', field: fieldAR, value: valueAR },
  ];

  const renderTraducoes = () =>
    traducoes
      .filter(({ idioma, field, value }) => !idioma || (field && value))
      .map(({ idioma, label, value }) => (
        <div key={idioma ?? 'default'}>
          <div className="tw:font-bold tw:text-black">
            {label ?? intl.formatMessage({ id: idioma })}
          </div>
          <div className="tw:ps-2.5">{value}</div>
        </div>
      ));

  return (
    <div>
      <div className="row">
        <div className="col-md-11 font-weight-bolder">{renderInput()}</div>
        <div className="col-md-1 font-weight-bolder d-flex align-items-center justify-content-center">
          <HoverCard className="tw:w-87.5" content={renderTraducoes()}>
            <LucideIcon
              onClick={() => handleTraducao()}
              style={{ cursor: 'pointer', marginTop: 15, marginLeft: 5 }}
              icon="web"
              size={22}
              className="ml-1"
            />
          </HoverCard>
        </div>
      </div>
    </div>
  );
};

export default InputTranslate;
